import { useState } from "react";
import { format } from "date-fns";
import { kk } from "date-fns/locale";

const months = [
  { number: 0, label: "Қаңтар" },
  { number: 1, label: "Ақпан" },
  { number: 2, label: "Наурыз" },
  { number: 3, label: "Сәуір" },
  { number: 4, label: "Мамыр" },
  { number: 8, label: "Қыркүйек" },
  { number: 9, label: "Қазан" },
  { number: 10, label: "Қараша" },
  { number: 11, label: "Желтоқсан" },
];

const CalendarGrid = ({ selectedDate, onSelectDate }) => {
  const currentYear = new Date().getFullYear();
  const selectedMonth = selectedDate.getMonth();

  const handleMonthSelect = (month) => {
    const newDate = new Date(currentYear, month, 1);
    onSelectDate(newDate);
  };

  return (
    <div>
      <h2 className="text-xl font-bold mb-6">Айлар</h2>

      <div className="grid grid-cols-3 gap-4">
        {months.map((month) => (
          <button
            key={month.number}
            onClick={() => handleMonthSelect(month.number)}
            className={`py-6 rounded-2xl text-center font-semibold transition-colors ${
              selectedMonth === month.number
                ? "bg-[#674DA2] text-white hover:bg-[#5b4196]"
                : "bg-[#EDE7F6] text-purple-900 hover:bg-[#674DA2] hover:text-white"
            }`}
          >
            {month.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CalendarGrid;
